module.exports = __webpack_public_path__ + "static/media/background.9392fe73.png";